import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
import Logger from "@cappelendamm/logger";
export const deleteSubscriptionContract = async ({ id }, { client }) => {
    Logger.log("Deleting subscription contract in Crystallize: ", id);
    const data = await client.subscriptions.request(graphql(`
        mutation DeleteSubscriptionContract($id: ID!) {
          subscriptionContracts {
            delete(id: $id)
          }
        }
      `), { id });
    if (data.subscriptionContracts?.delete) {
        return data.subscriptionContracts.delete > 0;
    }
    return false;
};
